import Address from "@/components/Address"
import { Input, Textarea } from '@/components/ui'
import { formatDate, formatPhoneNumber, formatPrice } from '@/utils/formatters'
import EmailLink from '@/components/EmailLink'
import { getInterventionStatusLabel, getMaterielStatusLabel, getFacturationStatusLabel } from '@/features/interventions/interventionsSlice'

export default ({ intervention }) => {

  return (
    <div className="bg-base-200 p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

        <div>
          <Input.Display label="Adresse" value={intervention.bien?.ville} forceEmptyPlaceholder={true} className="flex mb-2">
            <Address data={intervention.bien} withApptNumber={true} />
          </Input.Display>
          { intervention?.date_intervention &&
            <Input.Display label="Date de l'intervention" value={formatDate(intervention?.date_intervention || '')} />
          }
          { intervention?.montant &&
            <Input.Display label="Montant" value={formatPrice(intervention?.montant || '')} />
          }
        </div>
      
        <div>
          <Textarea.Display label="Détail de l'intervention" value={intervention?.details || ''}
            className='flex flex-col items-start mb-2'
          />
          <Input.Display label="Coordonnées locataire" 
            value={intervention.locataires?.length > 0} 
            forceEmptyPlaceholder={true} 
            className={intervention.locataires?.length > 0 ? "flex flex-col mb-2" : "flex mb-2"}
          >
          { intervention.locataires?.length > 0 && intervention.locataires.map(
            (contact, index) => (
              <div key={index}>
                {contact.nom_complet}
                {contact.telephone && <span className="pl-2">/ {formatPhoneNumber(contact.telephone)}</span>}
                {contact.email && <span className="pl-2">/ <EmailLink email={contact.email} /></span>}
              </div>
            )
          )}
          </Input.Display>
        </div>

        <div>
          <Input.Display 
            label="Statut de l'intervention" 
            value={intervention?.statut ? 
              getInterventionStatusLabel(intervention.statut) : 
              '' 
            }
          />
          { intervention?.statut_materiel && 
            <Input.Display 
              label="Statut du matériel" 
              value={intervention?.statut_materiel ? 
                getMaterielStatusLabel(intervention.statut_materiel) : 
                ''
              } 
              />
          }
          { intervention?.statut_facturation && 
            <Input.Display 
              label="Statut de la facturation" 
              value={intervention?.statut_facturation ?
                getFacturationStatusLabel(intervention.statut_facturation) : 
                ''
              } 
            />
          }
          { intervention.facture_adresse ?
            <Input.Display label="Entité à facturer" className='flex flex-col'>
              <div>{intervention.facture_adresse?.nom || ''}</div>
              { intervention.facture_adresse?.complement && 
                <div className="uppercase">{intervention.facture_adresse.complement}</div>
              }
              <Address data={intervention?.facture_adresse || {}}/>
            </Input.Display> :
            <Input.Display label="Entité à facturer" />
          }
        </div> 
      </div>
    </div>
  )
}